/**
 * Feature Flags Utility
 * Centralizes management of feature flags for the application.
 * Flags are typically controlled via environment variables.
 */

export const FEATURE_FLAGS = {
    // Phone authentication (requires SMS provider in Supabase)
    PHONE_AUTH: process.env.REACT_APP_ENABLE_PHONE_AUTH === 'true'
}

/**
 * Check if a feature is enabled
 * @param {string} flag - Key from FEATURE_FLAGS
 * @returns {boolean}
 */
export const isFeatureEnabled = (flag) => FEATURE_FLAGS[flag] ?? false

export default FEATURE_FLAGS
